// extracted by mini-css-extract-plugin
export default {"page":"uY-z","cartModal":"vY-z","checkout":"wY-z","placeholder":"xY-z","account":"yY-z"};